import { useState, useEffect } from 'react'
import breakpoints from '@/configs/tailwind/tokens/breakpoints'

/**
 * @Note I know of no way right now where 'breakpoint' can be
 * more exactly typed with a union of number values because tailwindcss
 * is not written in typescript, and doesn't have typescript support
 * So to mitigate that, I've added runtime check for now.
 */

export default function useMediaQuery({
  breakpointToken,
  overRideBreakpoint,
}: {
  breakpointToken?: string
  overRideBreakpoint?: number
}) {
  if (!(overRideBreakpoint || breakpointToken)) {
    throw new Error(
      'you need to pass either overRideBreakpoint or breakpointToken options',
    )
  }

  if (!overRideBreakpoint && breakpointToken && !breakpoints[breakpointToken]) {
    throw new Error(
      `${breakpointToken} breakpoint/screen tailwindcss token should be the one defined in tailwind config file`,
    )
  }

  const query = breakpointToken
    ? `(min-width: ${breakpoints[breakpointToken]})`
    : `(min-width: ${overRideBreakpoint}px)`

  const [matches, setMatches] = useState<boolean | null>(null)

  useEffect(() => {
    const media = window.matchMedia(query)
    if (media.matches !== matches) {
      setMatches(media.matches)
    }
    const listener = () => {
      setMatches(media.matches)
    }
    media.addListener(listener)
    return () => media.removeListener(listener)
  }, [matches, query])

  return matches
}
